import { pageId } from "utils/pageId";

export default () => ({
    projectGroup: {
        root: pageId("ProjectGroup.Edit", "Project Group"),
    },
});
